import { render, staticRenderFns } from "./risk-tolerance.vue?vue&type=template&id=078799ec"
import script from "./risk-tolerance.vue?vue&type=script&lang=ts"
export * from "./risk-tolerance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports